export default __webpack_public_path__ + "static/media/Upload.1a8c69ed.svg";